<template>
  <v-container>
    <div class="back-nav">
      <!--        Intentionally Empty-->
    </div>

    <div class="mb-4">
      <h1 class="page-title">
        <v-icon>$reportsLarge</v-icon>
        Reports
      </h1>
    </div>

    <v-tabs hide-slider v-model="activeTab" class="secondary-nav">
      <v-tab
        v-for="tab in tabs"
        :key="`${tab.name}-tab`"
        :to="`#${tab.route}`"
        :disabled="tab.disabled"
        >{{ tab.name }}</v-tab
      >
    </v-tabs>

    <v-tabs-items v-model="activeTab">
      <v-tab-item
        v-for="tab in tabs"
        :key="`${tab.name}-tabitem`"
        :value="tab.route"
      >
        <component :is="tab.component" :is-active="activeTab === tab.route" />
      </v-tab-item>
    </v-tabs-items>
  </v-container>
</template>

<script>
import ComplianceReport from "@/views/reports/ComplianceReport";
import SharedReports from "@/views/reports/SharedReports";
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("vendor");

const tabs = [
  {
    name: "Reports",
    route: "compliance",
    component: ComplianceReport,
    disabled: false
  },
  {
    name: "Shared Reports",
    route: "shared-reports",
    component: SharedReports,
    disabled: true
  }
];

export default {
  name: "Reports",
  props: ["initialTab"],
  data: () => ({
    tabs,
    activeTab: null
  }),
  components: {
    ComplianceReport
  },
  created() {
    this.logEvent("Landed on Reports page");
  },
  computed: {
    ...mapGetters(["hasEMSubscription"])
  },
  watch: {
    hasEMSubscription: {
      immediate: true,
      handler(val) {
        this.tabs[1].disabled = !val;
      }
    }
  }
};
</script>

<style lang="sass" scoped>
.report-container-wrapper.card-with-highlight
  border-top-width: 8px
  padding: 0 !important
</style>
